import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import AppTemplate from '@/app/shared/ui/templates/AppTemplate.vue';
import { computed, ref, reactive, inject } from 'vue';
import rules from '@/app/shared/domain/data/rules';
import InputMoney from '@/app/shared/components/inputs/InputMoney.vue';
import InputBank from '@/app/shared/components/inputs/InputBank.vue';
import InputNumber from '@/app/shared/components/inputs/InputNumber.vue';
import InputCostCenter from '@/app/shared/components/inputs/InputCostCenter.vue';
import InputBankCompanyList from '@/app/shared/components/inputs/InputBankCompanyList.vue';
import InputClients from '@/app/shared/components/inputs/InputClients.vue';
import BillReceivable from '@/app/bill-receivable/domain/interfaces/BillReceivable';
import Tabs from '@/app/shared/components/Tabs.vue';
import { useForm } from '@/app/shared/ui/composable/form';
import StatusMapper from '@/app/shared/application/StatusMapper';
import BillReceivableRepository from '../../infrastructure/persistence/BillReceivableRepository';
import useNotificationRepository from '@/app/shared/infrastructure/persistence/notification-repository';


export default /*#__PURE__*/_defineComponent({
  __name: 'BillReceivableForm',
  props: ['id'],
  setup(__props) {

const props = __props;

const form = ref(null);

const repository = inject('billReceivableRepository') as BillReceivableRepository;
const notificationRepository = useNotificationRepository();

let billReceivable = reactive({
    status: 'pending',
    values: {},
} as BillReceivable);

const { pageTitle, submit, isEditPage } = useForm(
    props,
    billReceivable,
    repository,
    form,
    'Editar conta a receber',
    'Cadastrar conta a receber',
    '/contas-a-receber',
    '/contas-a-receber',
);

const handleReceive = async () => {
    await repository.receive(billReceivable.id);

    notificationRepository.insert({id: Date.now().toString(), type: 'success', message: 'Conta recebida com sucesso'});

    billReceivable.status = 'received';
};

const canReceive = computed(() => {
    return isEditPage.value ? billReceivable.status !== 'received' : false;
});

const tabItens = [
    {
        icon: 'mdi:mdi-book-open',
        key: 'main',
        title: 'Principal'
    },
    {
        icon: 'mdi:mdi-plus-circle-outline',
        key: 'add',
        title: 'Adicionais'
    },
];

return (_ctx: any,_cache: any) => {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createBlock(AppTemplate, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { justify: "space-around" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { width: "100%" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar, { color: "surface" }, {
                append: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: _unref(submit),
                    "prepend-icon": "mdi:mdi-content-save",
                    color: "primary",
                    variant: "flat"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Salvar")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_toolbar_title, { class: "text-h6" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(pageTitle)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_form, {
                    "lazy-validation": "",
                    ref_key: "form",
                    ref: form
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Tabs, { itens: tabItens }, {
                        main: _withCtx(() => [
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createVNode(_component_v_text_field, {
                                            label: "Data de emissão",
                                            rules: [_unref(rules).date, _unref(rules).required],
                                            modelValue: _unref(billReceivable).issue_date,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(billReceivable).issue_date) = $event))
                                          }, null, 8, ["rules", "modelValue"]), [
                                            [_directive_mask, '##/##/####']
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        md: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field, {
                                            rules: [_unref(rules).required],
                                            label: "Descrição",
                                            modelValue: _unref(billReceivable).description,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(billReceivable).description) = $event))
                                          }, null, 8, ["rules", "modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(InputClients, {
                                            rules: [_unref(rules).required],
                                            label: "Cliente",
                                            modelValue: _unref(billReceivable).client_id,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(billReceivable).client_id) = $event))
                                          }, null, 8, ["rules", "modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createVNode(_component_v_text_field, {
                                            label: "Vencimento",
                                            rules: [_unref(rules).date, _unref(rules).required],
                                            modelValue: _unref(billReceivable).due_date,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(billReceivable).due_date) = $event))
                                          }, null, 8, ["rules", "modelValue"]), [
                                            [_directive_mask, '##/##/####']
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      (_unref(isEditPage))
                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                            key: 0,
                                            cols: "12",
                                            sm: "6"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_text_field, {
                                                label: "Status",
                                                readonly: "",
                                                "model-value": _unref(StatusMapper).map(_unref(billReceivable).status)
                                              }, null, 8, ["model-value"])
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(InputBankCompanyList, {
                                            rules: [_unref(rules).required],
                                            modelValue: _unref(billReceivable).account_id,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(billReceivable).account_id) = $event))
                                          }, null, 8, ["rules", "modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field, {
                                            label: "Observação",
                                            modelValue: _unref(billReceivable).observations,
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(billReceivable).observations) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_divider, { class: "my-10" }),
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6",
                                        md: "4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(InputMoney, {
                                            rules: [_unref(rules).required],
                                            label: "Valor do título",
                                            modelValue: _unref(billReceivable).values.main,
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(billReceivable).values.main) = $event))
                                          }, null, 8, ["rules", "modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6",
                                        md: "4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(InputMoney, {
                                            label: "Acréscimo",
                                            modelValue: _unref(billReceivable).values.add,
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(billReceivable).values.add) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6",
                                        md: "4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(InputMoney, {
                                            label: "Iss",
                                            modelValue: _unref(billReceivable).values.iss,
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(billReceivable).values.iss) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6",
                                        md: "4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(InputMoney, {
                                            label: "Irrf",
                                            modelValue: _unref(billReceivable).values.irrf,
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(billReceivable).values.irrf) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6",
                                        md: "4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(InputMoney, {
                                            label: "Reajuste",
                                            modelValue: _unref(billReceivable).values.readjustment,
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(billReceivable).values.readjustment) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6",
                                        md: "4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(InputMoney, {
                                            label: "Correção",
                                            modelValue: _unref(billReceivable).values.correction,
                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(billReceivable).values.correction) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6",
                                        md: "4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(InputMoney, {
                                            label: "Desconto",
                                            modelValue: _unref(billReceivable).values.discount,
                                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(billReceivable).values.discount) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6",
                                        md: "4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(InputMoney, {
                                            label: "Multa",
                                            modelValue: _unref(billReceivable).values.assessment,
                                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(billReceivable).values.assessment) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6",
                                        md: "4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(InputMoney, {
                                            label: "Juros",
                                            modelValue: _unref(billReceivable).values.fees,
                                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(billReceivable).values.fees) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6",
                                        md: "4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(InputMoney, {
                                            rules: [_unref(rules).required],
                                            label: "Saldo a receber",
                                            modelValue: _unref(billReceivable).values.balance_to_receive,
                                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(billReceivable).values.balance_to_receive) = $event))
                                          }, null, 8, ["rules", "modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6",
                                        md: "4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(InputMoney, {
                                            label: "Liquido baixado",
                                            modelValue: _unref(billReceivable).values.net_received,
                                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(billReceivable).values.net_received) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  (_unref(isEditPage))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createVNode(_component_v_divider, { class: "my-10" }),
                                        (_unref(canReceive))
                                          ? (_openBlock(), _createBlock(_component_v_row, {
                                              key: 0,
                                              class: "justify-center justify-sm-end"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, {
                                                  cols: "6",
                                                  sm: "3",
                                                  class: "justify-center d-flex"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_btn, {
                                                      onClick: handleReceive,
                                                      "prepend-icon": "fa-solid fa-money-bill",
                                                      color: "primary"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("Receber")
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        add: _withCtx(() => [
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Número do cheque",
                                    modelValue: _unref(billReceivable).check_number,
                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(billReceivable).check_number) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(InputBank, {
                                    label: "Banco",
                                    modelValue: _unref(billReceivable).check_code_bank,
                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(billReceivable).check_code_bank) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Agência cheque + dígito",
                                    modelValue: _unref(billReceivable).check_agency,
                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(billReceivable).check_agency) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Conta cheque + dígito",
                                    modelValue: _unref(billReceivable).check_account,
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(billReceivable).check_account) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_switch, {
                                    modelValue: _unref(billReceivable).generates_dirf,
                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(billReceivable).generates_dirf) = $event)),
                                    inset: "",
                                    color: "primary",
                                    label: "Gera dirf"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Código de retenção",
                                    modelValue: _unref(billReceivable).retention_code,
                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(billReceivable).retention_code) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(InputMoney, {
                                    label: "Inss retido",
                                    modelValue: _unref(billReceivable).retention_inss,
                                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(billReceivable).retention_inss) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Id darf",
                                    modelValue: _unref(billReceivable).darf_id,
                                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(billReceivable).darf_id) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(InputMoney, {
                                    label: "Taxa de permanência",
                                    modelValue: _unref(billReceivable).permanence_tax,
                                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(billReceivable).permanence_tax) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(InputNumber, {
                                    label: "% de juros",
                                    modelValue: _unref(billReceivable).percent_fees,
                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_unref(billReceivable).percent_fees) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Número do borderô",
                                    modelValue: _unref(billReceivable).bordero_number,
                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_unref(billReceivable).bordero_number) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(InputCostCenter, {
                                    modelValue: _unref(billReceivable).cost_center_id,
                                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_unref(billReceivable).cost_center_id) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Classificação",
                                    modelValue: _unref(billReceivable).classification,
                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_unref(billReceivable).classification) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Rateio",
                                    modelValue: _unref(billReceivable).apportionment,
                                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_unref(billReceivable).apportionment) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Ocorrência cnab",
                                    modelValue: _unref(billReceivable).cnab_occurrence,
                                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_unref(billReceivable).cnab_occurrence) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Id cnab",
                                    modelValue: _unref(billReceivable).cnab_id,
                                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_unref(billReceivable).cnab_id) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Origem",
                                    modelValue: _unref(billReceivable).origin,
                                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_unref(billReceivable).origin) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(InputMoney, {
                                    label: "Inss",
                                    modelValue: _unref(billReceivable).inss_value,
                                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_unref(billReceivable).inss_value) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(InputNumber, {
                                    label: "Parcela inss",
                                    modelValue: _unref(billReceivable).inss_installment,
                                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_unref(billReceivable).inss_installment) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Número de liquidação",
                                    modelValue: _unref(billReceivable).liquidation_number,
                                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_unref(billReceivable).liquidation_number) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 512)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})